<template>
  <div v-if="!modelChoosen">
    <h1 style="text-align: center; margin-top: 2rem">
      Choose model
    </h1>
    <div style="margin-top: 2rem">
      <carousel
        ref="carousel"
        :per-page="perPage"
        :touch-drag="false"
        :mouse-drag="false"
        navigation-enabled
        navigation-next-label="<i aria-hidden=&quot;true&quot; id=&quot;carousel-next&quot; class=&quot;material-icons&quot; style=&quot;position: absolute; bottom:130%; color: #212121; right:100%; z-index:5&quot;>arrow_forward_ios</i>"
        navigation-prev-label="<i aria-hidden=&quot;true&quot; id=&quot;carousel-prev&quot;  class=&quot;material-icons reverse&quot; style=&quot;position: absolute;width:24px; bottom:130%; color:#212121; left:100%;&quot;>arrow_forward_ios</i>"
      >
        <slide
          v-for="(item, i) in slides"
          :key="i"
          :class="{
            'half-width': perPage == 2,
            selected: typeof item == 'object' && item.selected,
          }"
          @slideclick="slideClick(item)"
        >
          <img
            :src="item.image_url"
            :class="{ modelSelected: isActive === i }"
            style="border: 2px solid transparent;"
            @click="switchModel(i, item.model_id)"
          />
          <p
            style="font-size: x-large; padding-top: 0.5rem; text-align: center"
          >
            {{ item.model_id }}
          </p>
          <p
            style="
              font-size: large;
              padding-top: 0.5rem;
              text-align: center;
              color: grey;
            "
          >
            {{ item.model_height }} cm Taille {{ item.model_garment_size }}
          </p>
        </slide>
      </carousel>
    </div>
    <button
      class="virtual"
      style="display: block; margin: auto; color: white; margin-top: 2rem"
      @click="submit"
    >
      <p style="font-size: x-large">
        Choose
      </p>
    </button>
  </div>
  <div v-else>
    <select
      v-model="selectedGarment"
      style="
        width: 100%;
        text-align: center;
        margin: auto;
        border-radius: 0;
        border: 0px solid grey;
        padding: 0.5rem;
        background-color: #dddddd;
        color: #686868;
        font-size: x-large;
        font-weight: bold;
      "
      @change="selectGarment"
    >
      <option value="top">
        TOP
      </option>
      <option value="bottoms">
        BOTTOMS
      </option>
      <!-- <option value="dress">DRESS</option>
      <option value="outerwear">OUTERWEAR</option> -->
    </select>
    <div v-if="look.image_urls">
      <div style="display: flex; position: relative; left: 2rem; height: 59%">
        <div style="width: 12%; margin: 1rem">
          <img
            :src="look.image_urls[0]"
            style="
              width: 100%;
              border-radius: 5px;
              border: 1px solid grey;
              margin-bottom: 1rem;
            "
            @click="switchModelUrl(look.image_urls[0])"
          />
          <img
            :src="look.image_urls[1]"
            style="width: 100%; border-radius: 5px; border: 1px solid grey"
            @click="switchModelUrl(look.image_urls[1])"
          />
        </div>
        <div style="width: 88%">
          <img
            :src="current_url"
            style="
              width: 70%;
              border-radius: 5px;
              border: 1px solid grey;
              margin-top: 1rem;
              margin-bottom: 1rem;
            "
          />
        </div>
      </div>
    </div>
    <carousel
      v-if="selectedGarment === 'top'"
      ref="carousel"
      :per-page="perPage"
      :touch-drag="false"
      :mouse-drag="false"
      navigation-enabled
      navigation-next-label="<i aria-hidden=&quot;true&quot; id=&quot;carousel-next&quot; class=&quot;material-icons&quot; style=&quot;position: absolute; bottom:130%; color: #212121; right:100%; z-index:5&quot;>arrow_forward_ios</i>"
      navigation-prev-label="<i aria-hidden=&quot;true&quot; id=&quot;carousel-prev&quot;  class=&quot;material-icons reverse&quot; style=&quot;position: absolute;width:24px; bottom:130%; color:#212121; left:100%;&quot;>arrow_forward_ios</i>"
    >
      <slide
        v-for="(item, i) in garments.top"
        :key="i"
        :class="{
          'half-width': perPage == 2,
          selected: typeof item == 'object' && item.selected,
        }"
        style="text-align: center;"
        @slideclick="slideClick(item)"
      >
        <img
          :src="item.image_url"
          :class="{ modelSelected: isTopActive === i && top_id === item.garment_id }"
          style="border: 2px solid transparent;object-fit: cover; object-position: center; margin-top: 2rem; position: relative; width: 90px !important; height: 90px !important; border-radius: 10px;"
          @click="switchTop(i, item.garment_id)"
        />

        <p style="padding-top: 0.5rem; text-align: center">
          {{ item.product_name }}
        </p>
        <p
          style="
            font-size: large;
            padding-top: 0.5rem;
            text-align: center;
            color: grey;
          "
        >
          {{ item.product_price }} {{ item.product_currency }}
        </p>
      </slide>
    </carousel>
    <!-- TOPS-->
    <carousel
      v-if="selectedGarment === 'bottoms'"
      ref="carousel"
      :per-page="perPage"
      :touch-drag="false"
      :mouse-drag="false"
      navigation-enabled
      navigation-next-label="<i aria-hidden=&quot;true&quot; id=&quot;carousel-next&quot; class=&quot;material-icons&quot; style=&quot;position: absolute; bottom:130%; color: #212121; right:100%; z-index:5&quot;>arrow_forward_ios</i>"
      navigation-prev-label="<i aria-hidden=&quot;true&quot; id=&quot;carousel-prev&quot;  class=&quot;material-icons reverse&quot; style=&quot;position: absolute;width:24px; bottom:130%; color:#212121; left:100%;&quot;>arrow_forward_ios</i>"
    >
      <slide
        v-for="(item, i) in garments.bottom"
        :key="i"
        :class="{
          'half-width': perPage == 2,
          selected: typeof item == 'object' && item.selected,
        }"
        style="text-align: center;"
        @slideclick="slideClick(item)"
      >
        <img
          :src="item.image_url"
          :class="{ modelSelected: isBottomActive === i && bottom_id === item.garment_id }"
          style="border: 2px solid transparent; object-fit: cover; object-position: center; margin-top: 2rem; position: relative; width: 90px !important; height: 90px !important; border-radius: 10px;"
          @click="switchBottom(i, item.garment_id)"
        />

        <p style="padding-top: 0.5rem; text-align: center">
          {{ item.product_name }}
        </p>
        <p
          style="
            font-size: large;
            padding-top: 0.5rem;
            text-align: center;
            color: grey;
          "
        >
          {{ item.product_price }} {{ item.product_currency }}
        </p>
      </slide>
    </carousel>
    <!-- BOTTOMS-->
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "Virtual",
  components: {
    Carousel,
    Slide,
  },
  props: {},
  data: () => {
    return {
      perPage: 2,
      isActive: '',
      isTopActive: '',
      isBottomActive: '',
      slides: [],
      garments: [],
      modelChoosen: false,
      model_id: "",
      top_id: "",
      bottom_id: "",
      selectedGarment: "top",
      look: "",
      current_url: "",
    };
  },
  computed: {},
  watch: {},
  async mounted() {
    this.slides = await this.$store.dispatch("FETCH_MODELS");
    this.garments = await this.$store.dispatch("FETCH_GARMENTS");
  },
  methods: {
    switchModel(index, name) {
      this.isActive = index === this.isActive ? "" : index;
      this.model_id = name;
    },
    async submit() {
      if (this.model_id !== "") {
        this.modelChoosen = true;
        let model = this.model_id,
          top = "T-shirt court",
          bottom = "Cycliste Marius (version blanche)";
        let params = { model, top, bottom };
        this.look = await this.$store.dispatch("FETCH_LOOK", params);
        this.current_url = this.look.image_urls[0];
        this.top_id = top;
        this.bottom_id = bottom;
      }
    },
    selectGarment() {},
    async switchTop(index, name) {
      this.isTopActive = index === this.isTopActive ? "" : index;
      this.top_id = name;

      let model = this.model_id,
        top = this.top_id,
        bottom = this.bottom_id;
      let params = { model, top, bottom };
      this.look = await this.$store.dispatch("FETCH_LOOK", params);
      this.current_url = this.look.image_urls[0];
    },
    async switchBottom(index, name) {
      this.isBottomActive = index === this.isBottomActive ? "" : index;
      this.bottom_id = name;

      let model = this.model_id,
        top = this.top_id,
        bottom = this.bottom_id;
      let params = { model, top, bottom };
      this.look = await this.$store.dispatch("FETCH_LOOK", params);
      this.current_url = this.look.image_urls[0];
    },
    switchModelUrl(url) {
      this.current_url = url;
    },
  },
};
</script>